<script>
  import {
    assign,
    cloneDeep,
    debounce,
    isEmpty,
    isEqual,
    pickBy,
    merge,
    some,
  } from 'lodash'
  import GenericStoreCoordinatorService from 'Services/genericStoreCoordinator/Service'

  function valueIsAllowedInFilterProxy (val) {
    return val || val === false || (Array.isArray(val) && val.length > 0)
  }

  export default {
    data () {
      return {
        advancedProps: [], // Override this to check if advanced filters are dirty
        coordinator: GenericStoreCoordinatorService.getById(this.uuid),
        filterProxy: {},
        defaultFilterMerge: {},
      }
    },
    props: {
      uuid: {
        type: String,
        required: true,
      },
    },
    fromMobx: {
      coordinatorFilter () {
        return this.coordinator.filter
      },
      coordinatorMergedFilter () {
        return this.coordinator.mergedFilter
      },
      coordinatorSortOrder () {
        return this.coordinator.sortOrder.length ? this.coordinator.sortOrder[0] : undefined
      },
    },
    computed: {
      advancedFiltersDirty () {
        return some(
          this.advancedProps.map(p => {
            return (
              this.filterProxy[p] !== undefined &&
              this.filterProxy[p] !== '' &&
              this.filterProxy[p].length !== 0
            )
          })
        )
      },
    },
    methods: {
      updateFilterProxy (key, value, valueTransform = v => v) {
        // - Had to do this really fancy merge to make the obj reference change, so the
        // `filterProxy` watcher would fire properly.
        // - `pickBy` is to remove falsey keys from the filter (except for 'false' itself). This is if the user
        // clears a filter field input box, it will get removed from the filter instead of
        // being sent to the API as an empty string.
        //                                                                           Love,
        //                                                                           Tyler Petresky
        this.filterProxy = pickBy(
          assign({}, this.filterProxy, { [key]: valueTransform(value) }),
          valueIsAllowedInFilterProxy
        )
      },
      updateFilterProxyWithChangeset (changeset = {}) {
        pickBy(assign({}, this.filterProxy, changeset), valueIsAllowedInFilterProxy)
      },
      setSortOrder (sortField, direction) {
        this.coordinator.sortOrder = [{ sortField, direction }]
      },
    },
    created () {
      // Only request a certain number of records to display
      this.coordinator.mergeFields = merge({}, this.coordinator.mergeFields, {
        per_page: 30,
      })

      // Add debounce to the update function
      this.updateFilterProxy = debounce(this.updateFilterProxy, 150)
      if (!isEmpty(this.coordinatorFilter)) {
        this.filterProxy = cloneDeep(this.coordinatorFilter)
      }

      // We only want to start watching after filterProxy is set the first time
      // TODO: possibly move this to a top-level watch key, checking for oldVal !== null/undefined
      this.$watch('filterProxy', (newVal, oldVal) => {
        if (newVal) {
          this.coordinator.filter = cloneDeep(this.filterProxy)
        }
      })
      this.$watch('coordinatorFilter', (newVal, oldVal) => {
        if (!isEqual(newVal, this.filterProxy)) {
          this.filterProxy = newVal
        }
      })
    },
  }
</script>
